<template>
  <svg aria-hidden="true" viewBox="0 0 16 16" fill="currentColor">
    <path d="M11.8,2.8H10c-0.6,0-0.7,0.3-0.7,0.9v1.5h2.5l-0.2,2.7H9.3V16H6V8H4.4V5.2H6V3.1 C6,1.1,7.1,0,9.5,0h2.2L11.8,2.8z"/>
  </svg>
</template>
